import { UpdateDispatchConfigRequest } from '@core/models/dispatch/update-dispatch-config-request';
import { DISPATCH_CONFIG_FETCH, DISPATCH_CONFIG_UPDATE } from '@core/state/action-types';
import { DISPATCH_CONFIG_ENTITY } from '@core/state/entity-types';
import { ObservableAction } from '@core/state/shared/actions/observable-action';
import { SharedAction } from '@core/state/shared/actions/shared-action';
import { ListItemSetAction, ListSetFetchingAction } from '@core/state/shared/list/list.actions';
import { GROUP_DISPATCH_CONFIGS } from '@core/state/state-groups';
import { Action } from '@ngrx/store';

export class SetDispatchConfigAction
    extends ListItemSetAction
    implements SharedAction {
    name = GROUP_DISPATCH_CONFIGS;

    constructor(public override payload: any) {
        super(payload);
        payload.domain = DISPATCH_CONFIG_ENTITY;
    }
}
@ObservableAction()
export class FetchDispatchConfigAction implements Action {
    readonly type = DISPATCH_CONFIG_FETCH;

    constructor(
        public payload: {
            locationId: string;
        }
    ) {}
}

export class IsFetchingDispatchConfigAction
    extends ListSetFetchingAction
    implements SharedAction {
        
    name = GROUP_DISPATCH_CONFIGS;

    constructor(payload: any) {
        super(payload);
    }
}

@ObservableAction()
export class UpdateDispatchConfigAction implements Action {
    readonly type = DISPATCH_CONFIG_UPDATE;

    constructor(
        public payload: {
            locationId: string;
            request: UpdateDispatchConfigRequest;
        }
    ) {}
}
